import { type FunctionComponent, useCallback } from 'react';
import classnames from 'classnames';

import { useSharedStateSelector } from '@trello/shared-state';
import { workspaceState } from '@trello/workspaces';

import { PremiumLozenge } from './PremiumLozenge';
import { useHasReverseTrialExperience } from './useHasReverseTrialExperience';

import styles from './PremiumBanner.less';

export interface PremiumBannerProps {
  title: string;
  description: string;
  className?: string;
}

export const PremiumBanner: FunctionComponent<PremiumBannerProps> = ({
  title,
  description,
  className,
}) => {
  return (
    <div className={classnames(styles.PremiumBanner, className)}>
      <PremiumLozenge />
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
    </div>
  );
};

export const MaybePremiumBanner: FunctionComponent<PremiumBannerProps> = ({
  ...args
}) => {
  const workspaceId =
    useSharedStateSelector(
      workspaceState,
      useCallback((state) => state.workspaceId, []),
    ) || '';

  const hasReverseTrialExperience = useHasReverseTrialExperience(workspaceId);

  return hasReverseTrialExperience ? <PremiumBanner {...args} /> : null;
};
